import { Button } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { Buffer } from 'buffer';
import moment from 'moment';


function generateTXT(data, sortedParticipants) {
    console.log(data);
    console.log(sortedParticipants);

    // version
    let str = "PPL 1.0\n";

    // event data
    str += "ERZEUGE BUEHNE \"Bühne I\"\n";
    str += "STARTZEIT \"Bühne I\" \"" + moment.unix(data.startlist.timeStage1).format("HH:mm") + "\"\n";
    str += "ERZEUGE BUEHNE \"Bühne II\"\n";
    str += "STARTZEIT \"Bühne II\" \"" + moment.unix(data.startlist.timeStage2).format("HH:mm") + "\"\n";
    str += "TITEL \"" + data.startlist.title + "\"\n";
    str += "ORT \"" + data.startlist.location + "\"\n";
    str += "DATUM \"" + moment.unix(data.startlist.date).format("DD.MM.YYYY") + "\"\n";

    // startgroups
    for (let i = 0; i < data.sgs.length; i++) {
        const startGroup = data.startGroups.reduce((result, item) => {
            if (item.id === data.sgs[i]) {
                result = item;
            }
            return result;
        }, null);
        if (startGroup) {
            let type = 1;
            if (startGroup.id > 20) {
                type = 2;
            }
            if (startGroup.id > 50) {
                type = 0;
            }
            str += "ERZEUGE STARTGRUPPE \"" + startGroup.name + "\"\n";
            if (type > 0) {
                str += "PLATTLERDAUER \"" + startGroup.name + "\" " + startGroup.danceDuration + "\n";
                str += "PLATTLER \"" + startGroup.name + "\" \"" + startGroup.dance + "\"\n";
                str += "WERTUNGSTYP \"" + startGroup.name + "\" " + type + "\n";    
            }
            else {
                if (startGroup.duration) {
                    str += "PAUSE \"" + startGroup.name + "\" " + Math.floor(startGroup.duration/60) + "\n";    
                }
            }
        }
    }

    // participants
    const associations = {};
    for (let i = 0; i < sortedParticipants.length; i++) {
        const startGroup = sortedParticipants[i];
        for (let j = 0; j < startGroup.list.length; j++) {
            const participant = startGroup.list[j];
            if (!associations[participant.association]) {
                associations[participant.association] = true;
                str += "ERZEUGE VEREIN \"" + participant.association + "\"\n";
            }
            str += "TEILNEHMER \"" + participant.lastName + " " + participant.firstName + "\" ";
            str += "\"" + participant.association + "\" \"" + startGroup.title + "\"\n";
            str += "STARTNUMMER \"" + participant.lastName + " " + participant.firstName + "\" ";
            str += "\"" + participant.association + "\" \"" + startGroup.title + "\" " + participant.position + "\n";
        }
    }

    return str;
}

function SLTXT(props) {

    const clickHandler = () => {
        const str = generateTXT(props.data, props.sortedParticipants);
        const buffer = Buffer.from(str); //, "latin1");
        const blob = new Blob([buffer], { type: "text/ascii" });
        const a = document.createElement("a");
        a.style = "display:none";
        //a.href = "data:text/csv;charset=utf-8," + encodeURIComponent(data);
        a.href = window.URL.createObjectURL(blob);
        a.download = "Startliste.txt";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);    
    };

    return (
        <>
            <Button
                icon={<ExportOutlined/>}
                disabled={props.data.startGroups.length === 0}
                onClick={clickHandler}
            >
                Exportieren (TXT)
            </Button>
        </>
    );
}

export default SLTXT;
